// extracted by mini-css-extract-plugin
module.exports = {"outdoor-recreation":"PowerIndependence_outdoor-recreation__Y_x4x"};